<template>
    <div class="desktop-filters">
        <FilterInputs class="desktop-filters__selects" ref="filterPanelSelects">
            <DesktopClearFilters />
        </FilterInputs>
    </div>
</template>

<script>
    import FilterInputs from 'components/searchable-listing/filters-elements/FilterInputs'
    import DesktopClearFilters from 'components/searchable-listing/filters-elements/DesktopClearFilters'

    export default {
        name: 'DesktopFilters',
        components: {
            FilterInputs,
            DesktopClearFilters
        },
        methods: {
            getFilterPanelSelects () {
                return this.$refs.filterPanelSelects.$el.clientHeight
            }
        }
    }
</script>

<style scoped lang="scss">
    .desktop-filters {
        &__selects {
            display: flex;
            flex-direction: row;
            flex: 1;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
    }
</style>
